"use client";

import React from "react";
import { Facebook, Instagram, ArrowUp, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-300 font-default text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const socialLinks = [{
    icon: Instagram,
    href: "https://instagram.com/skylinehigh",
    label: "Instagram"
  }, {
    icon: Facebook,
    href: "https://facebook.com/skylinehigh",
    label: "Facebook"
  }];
  return <section data-section-id="265023" id="footer" className="bg-background text-foreground pt-20 pb-8 px-6 md:px-12 border-t border-border relative overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-5 select-none">
        <span className="font-serif text-[12rem] md:text-[20rem] font-bold tracking-tighter text-primary">
          Ad Astra
        </span>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-12 w-auto text-primary" />
            </Link>
            <p className="text-muted-foreground font-default text-sm leading-relaxed max-w-xs italic">
              "Ad Astra" — To the stars. Celebrating twenty years of excellence, friendship, and the enduring spirit of the Skyline High Class of 2005.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-xl font-semibold tracking-widest uppercase text-primary">Quick Links</h3>
            <MenuProvider menu_id="46">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-xl font-semibold tracking-widest uppercase text-primary">Event Details</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-muted-foreground">
                <MapPin className="w-5 h-5 shrink-0 mt-0.5 text-primary" />
                <span className="font-default text-sm">Skyline Grand Ballroom, 123 Heritage Way, Skyline City</span>
              </li>
              <li className="flex items-center space-x-3 text-muted-foreground">
                <Phone className="w-5 h-5 shrink-0 text-primary" />
                <span className="font-default text-sm">+1 (555) 2005-2025</span>
              </li>
              <li className="flex items-center space-x-3 text-muted-foreground">
                <Mail className="w-5 h-5 shrink-0 text-primary" />
                <span className="font-default text-sm">reunion@skylinehigh.edu</span>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-xl font-semibold tracking-widest uppercase text-primary">Stay Connected</h3>
            <p className="text-muted-foreground font-default text-sm mb-2">
              Follow our alumni channels for throwback photos and weekend updates.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, i) => <Link key={social.label} data-index={i} to={social.href} newTab className="w-10 h-10 rounded-md bg-secondary flex items-center justify-center text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-md hover:shadow-lg border border-primary/20" aria-label={social.label}>
                  <social.icon className="w-5 h-5" />
                </Link>)}
            </div>
          </div>
        </div>

        <Separator className="bg-border/30 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-muted-foreground font-default text-sm tracking-wide">
            &copy; {new Date().getFullYear()} Skyline High Class of 2005. All rights reserved.
          </p>
          
          <Button variant="outline" size="icon" onClick={scrollToTop} className="rounded-md border-primary/50 text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-md" aria-label="Back to top">
            <ArrowUp className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>;
}